import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { VivaInsightsLinkedService } from 'app/model/linkedservice/viva-insights.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(VivaInsightsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*'
        }
    }
})
export class VivaInsightsLinkedServiceAdapter extends LinkedServiceAdapter<VivaInsightsLinkedService> {
    protected modelConstructor(): new () => VivaInsightsLinkedService {
        return VivaInsightsLinkedService;
    }

    protected model(): IModel {
        return VivaInsightsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: VivaInsightsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.VivaInsightsLinkedService;
        properties.type = Metamodel.modelFor(VivaInsightsLinkedService).name;
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: VivaInsightsLinkedService): Promise<VivaInsightsLinkedService> {
        return linkedService;
    }
}
